import Vue from "vue";
import breakpoints from "@/assets/scss/_breakpoints.scss";
import {
  LayoutPlugin,
  ButtonPlugin,
  CardPlugin,
  ModalPlugin,
  CollapsePlugin,
  ListGroupPlugin,
  FormRadioPlugin,
  FormGroupPlugin,
  FormInputPlugin,
  FormSelectPlugin,
  InputGroupPlugin,
  IconsPlugin,
  OverlayPlugin,
  TablePlugin,
  SpinnerPlugin,
  PaginationPlugin,
  TooltipPlugin,
  FormCheckboxPlugin
} from "bootstrap-vue";

import VueScreen from "vue-screen";
Vue.use(LayoutPlugin);
Vue.use(ButtonPlugin);
Vue.use(CardPlugin);
Vue.use(ModalPlugin);
Vue.use(CollapsePlugin);
Vue.use(ListGroupPlugin);
Vue.use(FormRadioPlugin);
Vue.use(FormGroupPlugin);
Vue.use(FormInputPlugin);
Vue.use(FormSelectPlugin);
Vue.use(InputGroupPlugin);
Vue.use(IconsPlugin);
Vue.use(OverlayPlugin);
Vue.use(TablePlugin);
Vue.use(SpinnerPlugin);
Vue.use(PaginationPlugin);
Vue.use(TooltipPlugin);
Vue.use(FormCheckboxPlugin);
Vue.use(VueScreen, breakpoints);
